import React from "react";

import { FeaturedMedia as FeaturedMediaType } from "custom-types/Wordpress";

import Image from "components/Image";
import Video from "components/Video";

const NewsFeaturedMedia: React.FC<{
  media: FeaturedMediaType;
  isFeaturedArticle?: boolean;
}> = ({ media, isFeaturedArticle }) =>
  media?.url ? (
    <div className={isFeaturedArticle ? "pt-20 md:pt-none" : ""}>
      {media.type === "image" ? (
        <Image
          alt={media.altText}
          disableLazyLoad
          preload
          ratio="rectangle"
          sizes={
            isFeaturedArticle
              ? [544, 768, 1024, 1440, null, 768]
              : [400, 735, 550, 740, null, 740]
          }
          src={media.url}
        />
      ) : (
        <div>
          <Video
            playerId="article-featured-video"
            playerScript="https://video.leafly.com/libraries/QKPVtt8Y.js"
            playlist={`https://video.leafly.com/v2/media/${media.id}`}
          />
        </div>
      )}
      {!isFeaturedArticle && (
        <span className="block font-bold pt-xs text-green text-xs">
          {media.caption}
        </span>
      )}
    </div>
  ) : null;

export default NewsFeaturedMedia;
